import axios from 'axios'
import { buildings } from 'utils/geojson-buildings.js';
import defaultMarkerIconImage from 'images/marker-2.png';
import { clearWaypoints, clearRoutes } from 'actions/directionsActions';
import { 
  polygon_UmEmap,  
  map_maxZoomLevel,
  map_defaultZoomLevel,
} from 'utils/mapCoords';

export const NOMINATIM_URL = `${process.env.REACT_APP_NOMINATIM_URL}/search`
export const NOMINATIME_URL_REVERSE = `${process.env.REACT_APP_NOMINATIM_URL}/reverse`

export const defaultMarkerIcon = L.icon({
    iconUrl: defaultMarkerIconImage, 
    iconSize: [32, 32], 
    iconAnchor: [16, 24], 
  });

export const mapGetGeoJsonObject = (object_id) => { 
  // Find the object by id
  const buildingFeature = buildings.find((feature) => feature.properties['@id'] === object_id);

  // Return the object if found
  if (buildingFeature) {
    return buildingFeature;
  }

  // Return null if the building ID is not found or the geometry type is not supported
  return null;
};

const getLabelsAndValues = (properties, activeLang) => {
  let name, desc, email, phone, fax, websiteLinkName, busRouteRef, website;
  let phoneLabel, faxLabel, emailLabel, websiteLabel, busRouteRefLabel; 
  let routingLabel, copyLinkLabel;
  

  if (activeLang === 'zh') {
    phoneLabel = '電話';
    faxLabel = '傳真';
    emailLabel = '電郵';
    websiteLabel = '網址';
    websiteLinkName = '連結';
    busRouteRefLabel = '巴士路線';        
    routingLabel = '前往路徑';  
    copyLinkLabel = '複製連結';  
    name = properties["name:zh"] ? `<h5 style="width: 280px; word-wrap: break-word;">${properties["name:zh"]}</h5>` : properties["name"] ? `<h5 style="width: 280px; word-wrap: break-word;">${properties["name"]}</h5>` : '';
    //desc = properties["description:zh"] ? `<p style="width: 280px; word-wrap: break-word;">${properties["description:zh"]}</p>` : properties.description ? `<p style="width: 280px; word-wrap: break-word;">${properties.description}</p>` : '';
    desc = properties["description:zh"] ? `<p style="width: 280px; word-wrap: break-word;">${properties["description:zh"].replace(/所在位置:/g, '<strong>所在位置:</strong>')}</p>` : properties.description ? `<p style="width: 280px; word-wrap: break-word;">${properties.description.replace(/所在位置:/g, '<strong>所在位置:</strong>')}</p>` : '';
    email = properties["email:zh"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${emailLabel}: </strong>${properties["email:zh"]}</p>` : properties.email ? `<p style="width: 280px; word-wrap: break-word;"><strong>${emailLabel}: </strong>${properties.email}</p>` : '';
    phone = properties["phone:zh"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${phoneLabel}: </strong>${properties["phone:zh"]}</p>` : properties.phone ? `<p style="width: 280px; word-wrap: break-word;"><strong>${phoneLabel}: </strong>${properties.phone}</p>` : '';
    fax = properties["fax:zh"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${faxLabel}: </strong>${properties["fax:zh"]}</p>` : properties.fax ? `<p style="width: 280px; word-wrap: break-word;"><strong>${faxLabel}: </strong>${properties.fax}</p>` : '';  
    busRouteRef = properties["route_ref:zh"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${busRouteRefLabel}: </strong>${properties["route_ref:zh"]}</p>` : properties.route_ref ? `<p style="width: 280px; word-wrap: break-word;"><strong>${busRouteRefLabel}: </strong>${properties.route_ref}</p>` : '';  
    website = properties["website:zh"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${websiteLabel}:</strong> <a href="${properties["website:zh"]}" target="_blank" rel="noopener noreferrer">${websiteLinkName}</a></p>` : properties.website ? `<p style="width: 280px; word-wrap: break-word;"><strong>${websiteLabel}:</strong> <a href="${properties.website}" target="_blank" rel="noopener noreferrer">${websiteLinkName}</a></p>` : '';;
  } else { // default is 'en'
    phoneLabel = 'Phone';
    faxLabel = 'Fax';
    emailLabel = 'Email';
    websiteLabel = 'Website';
    websiteLinkName = 'Link';
    busRouteRefLabel = 'Bus Routes';
    routingLabel = 'Direction';    
    copyLinkLabel = 'Copy URL';
    name = properties["name:en"] ? `<h5 style="width: 280px; word-wrap: break-word;">${properties["name:en"]}</h5>` : properties["name"] ? `<h5 style="width: 280px; word-wrap: break-word;">${properties["name"]}</h5>` : '';
    //desc = properties["description:en"] ? `<p style="width: 280px; word-wrap: break-word;">${properties["description:en"]}</p>` : properties.description ? `<p style="width: 280px; word-wrap: break-word;">${properties.description}</p>` : '';
    desc = properties["description:en"] ? `<p style="width: 280px; word-wrap: break-word;">${properties["description:en"].replace(/Location:/g, '<strong>Location:</strong>')}</p>` : properties.description ? `<p style="width: 280px; word-wrap: break-word;">${properties.description.replace(/Location:/g, '<strong>Location:</strong>')}</p>` : '';
    email = properties["email:en"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${emailLabel}: </strong>${properties["email:en"]}</p>` : properties.email ? `<p style="width: 280px; word-wrap: break-word;"><strong>${emailLabel}: </strong>${properties.email}</p>` : '';
    phone = properties["phone:en"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${phoneLabel}: </strong>${properties["phone:en"]}</p>` : properties.phone ? `<p style="width: 280px; word-wrap: break-word;"><strong>${phoneLabel}: </strong>${properties.phone}</p>` : '';
    fax = properties["fax:en"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${faxLabel}: </strong>${properties["fax:en"]}</p>` : properties.fax ? `<p style="width: 280px; word-wrap: break-word;"><strong>${faxLabel}: </strong>${properties.fax}</p>` : '';
    busRouteRef = properties["route_ref:en"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${busRouteRefLabel}: </strong>${properties["route_ref:en"]}</p>` : properties.route_ref ? `<p style="width: 280px; word-wrap: break-word;"><strong>${busRouteRefLabel}: </strong>${properties.route_ref}</p>` : '';  
    website = properties["website:en"] ? `<p style="width: 280px; word-wrap: break-word;"><strong>${websiteLabel}:</strong> <a href="${properties["website:en"]}" target="_blank" rel="noopener noreferrer">${websiteLinkName}</a></p>` : properties.website ? `<p style="width: 280px; word-wrap: break-word;"><strong>${websiteLabel}:</strong> <a href="${properties.website}" target="_blank" rel="noopener noreferrer">${websiteLinkName}</a></p>` : '';;
  }

  const image = properties.image ? `<img src="${properties.image}" width="300" height="200" alt="Building" />` : '';
  //const website = properties.website ? `<p style="width: 280px; word-wrap: break-word;"><strong>${websiteLabel}:</strong> <a href="${properties.website}" target="_blank" rel="noopener noreferrer">${websiteLinkName}</a></p>` : '';

  return { name, desc, email, phone, fax, phoneLabel, faxLabel, emailLabel, websiteLabel, websiteLinkName, routingLabel, copyLinkLabel, image, website, busRouteRef };
};

export const generateInfoBoxHTML_byResult = (result, activeLang, callback) => {

  //console.log("In generateInfoBoxHTML_byResult, activeLang:", activeLang);

  if (!result) {
    return callback(null);
  }
  const properties = result.properties;
  const { name, desc, email, phone, fax, image, website, routingLabel, copyLinkLabel, busRouteRef} = getLabelsAndValues(properties, activeLang);

  getCurrentUserCoordinates((error, userCoord) => {
    if (error) {
      //console.error("Failed to get user coordinates:", error);
      const content = name + image + desc + phone + fax + email + busRouteRef + website;
      callback(`<div>${content}</div>`);
    } else {
      const geoJsonId = properties['@id'];
      const copyLink = `https://map.um.edu.mo?lang=${activeLang}&geoJsonId=${geoJsonId}`;

      //console.log("In getCurrentUserCoordinates, userCoord:", userCoord);

      const optionalFunction = 
        '<p style="width: 280px; word-wrap: break-word;">' + 
          '<table width="92%" align="center"><tr>' + 
            '<td align="center">' + 
              '<a class="button-InfoBoxHTML" href="?lang=' + activeLang + '&geoJsonId=' + geoJsonId + '&srcCoord=' + userCoord + '">' + routingLabel + '</a>' +
            '</td>' +              
            '<td align="center">' + 
              '<a class="button-InfoBoxHTML" href="#" onclick="navigator.clipboard.writeText(\'' + copyLink + '\').then(() => { alert(\'' + (activeLang === 'zh' ? '連結已複製' : 'URL copied') + '\'); })">' + copyLinkLabel + '</a>' +
            '</td>' +
          '</tr>' +
          '</table>' +                    
        '</p>';
      const content = name + image + desc + phone + fax + email + busRouteRef + website + optionalFunction;
      //const content = name + image + desc + phone + fax + email + website + optionalFunction + userCoord;
      callback(`<div>${content}</div>`);
    }
  });
};

export const generateInfoBoxHTML_inDirection = (result, activeLang) => {
  
  if (!result) {
    if (activeLang === 'zh') {
      return `<div style="text-align: center;">特定位置</div>`;  
    } else {
      return `<div style="text-align: center;">Specified Location</div>`;  
    }
  }



  const properties = result.properties;
  const { name, desc, email, phone, fax, image, website, copyLinkLabel, busRouteRef} = getLabelsAndValues(properties, activeLang);

  const geoJsonId = properties['@id'];
  const copyLink = `https://map.um.edu.mo?lang=${activeLang}&geoJsonId=${geoJsonId}`;  
  const optionalFunction = 
  '<p style="width: 280px; word-wrap: break-word;">' + 
    '<table width="92%" align="center"><tr>' + 
      '<td align="center">' + 
        '<a class="button-InfoBoxHTML" href="#" onclick="navigator.clipboard.writeText(\'' + copyLink + '\').then(() => { alert(\'' + (activeLang === 'zh' ? '連結已複製' : 'URL copied') + '\'); })">' + copyLinkLabel + '</a>' +
      '</td>' +
    '</tr>' +
    '</table>' +                    
  '</p>';

  const content = name + image + desc + phone + fax + email + busRouteRef + website + optionalFunction;

  return `<div>${content}</div>`;
};


export const generateInfoBoxHTML = (object_id, activeLang, callback) => {
  const result = buildings.find((feature) => feature.properties['@id'] === object_id);
  generateInfoBoxHTML_byResult(result, activeLang, callback);
};

export const generateLocationsName = (object_id, activeLang) => {   
  
  const result = buildings.find((feature) => feature.properties['@id'] === object_id);    
  let locationIDNotFound, locationNameNotFound;
  
  if (activeLang === 'en') {    
    locationIDNotFound = "The location could not be found.";
    locationNameNotFound = "No name";
  } else if (activeLang === 'zh') {
    locationIDNotFound = "找不到此地址";
    locationNameNotFound = "沒有名稱";
  } else if (activeLang === 'pt') {
    locationIDNotFound = "The location could not be found.";
    locationNameNotFound = "No name";
  } else { // default is 'en'
    locationIDNotFound = "The location could not be found.";
    locationNameNotFound = "No name";
  }

  if (!result) {
    return locationIDNotFound;
  }

  const properties = result.properties;

  let name;  
  if (activeLang === 'en') {
    if (properties["name:en"]) {
      name = properties["name:en"]
    } else if (properties["name"]) {
      name = properties["name"]
    } else {
      name = locationNameNotFound;
    }     
  } else if (activeLang === 'zh') {
    if (properties["name:zh"]) {
      name = properties["name:zh"]
    } else if (properties["name"]) {
      name = properties["name"]
    } else {
      name = locationNameNotFound;
    }     
  } else if (activeLang === 'pt') {
    if (properties["name:pt"]) {
      name = properties["name:pt"]
    } else if (properties["name"]) {
      name = properties["name"]
    } else {
      name = locationNameNotFound;
    }     
  } else { // default is 'en'  
    name = locationNameNotFound;
  }  
  
  return name;

};
export const generateLocationsDescription = (object_id, activeLang) => {

  const result = buildings.find((feature) => feature.properties['@id'] === object_id);  
  let locationIDNotFound, locationDescNotFound;
  
  if (activeLang === 'en') {    
    locationIDNotFound = "The location could not be found.";
    //locationDescNotFound = "No description";
    locationDescNotFound = "";
  } else if (activeLang === 'zh') {
    locationIDNotFound = "找不到此地址";
    //locationDescNotFound = "沒有描述";
    locationDescNotFound = "";
  } else if (activeLang === 'pt') {
    locationIDNotFound = "The location could not be found.";
    //locationDescNotFound = "No description";
    locationDescNotFound = "";
  } else { // default is 'en'
    locationIDNotFound = "The location could not be found.";
    //locationDescNotFound = "No description";
    locationDescNotFound = "";
  }

  if (!result) {
    return locationIDNotFound;
  }

  const properties = result.properties;

  let desc;  
  if (activeLang === 'en') {
    if (properties["description:en"]) {
      desc = properties["description:en"]
    } else if (properties["description"]) {
      desc = properties["description"]
    } else {
      desc = locationDescNotFound;
    }     
  } else if (activeLang === 'zh') {
    if (properties["description:zh"]) {
      desc = properties["description:zh"]
    } else if (properties["description"]) {
      desc = properties["description"]
    } else {
      desc = locationDescNotFound;
    }     
  } else if (activeLang === 'pt') {
    if (properties["description:pt"]) {
      desc = properties["description:pt"]
    } else if (properties["description"]) {
      desc = properties["description"]
    } else {
      desc = locationDescNotFound;
    }     
  } else { // default is 'en'  
    desc = locationDescNotFound;
  }  
  
  return desc;
};

export const mapGetGeoJsonIDsbyFilter = (filterName, filterValue) => {

  const resultIds = buildings
    .filter((feature) => feature.properties[filterName] === filterValue)
    .map((feature) => feature.properties['@id']);  

    if (resultIds.length === 0) {
    return "No locations found.";
  }

  return resultIds;
};
  
export const mapGetGeoJsonObjectCenter = (object_id) => {

  const buildingFeature = mapGetGeoJsonObject(object_id);

  if (buildingFeature) {
    const buildingGeometry = buildingFeature.geometry;
    const buildingCoordinates = buildingGeometry.coordinates;

    if (buildingGeometry.type === 'Polygon') {
      // Calculate the centroid of the polygon
      const centroid = L.polygon(buildingCoordinates).getBounds().getCenter();
      return [centroid.lng, centroid.lat];
    } else if (buildingGeometry.type === 'Point') {
      // Return the coordinates of the point
      return [buildingCoordinates[1], buildingCoordinates[0]];
    }
  }

  // Return null if the building ID is not found or the geometry type is not supported
  return null;
};
 
export const mapFlyToGeoJsonObject_byID = (map, geoJsonId, activeLang, customIcon = defaultMarkerIcon) => {
//export const mapFlyToGeoJsonObject_byID = (map, geoJsonId, activeLang) => {    
  if (map) {
    mapClearAllLayerContents(map);
    const layerGroup = L.layerGroup().addTo(map);
    layerGroup.type = 'location'; 

    if (geoJsonId) {
      const geoJsonCenter = mapGetGeoJsonObjectCenter(geoJsonId);

      if (geoJsonCenter) {
        generateInfoBoxHTML(geoJsonId, activeLang, (infoBoxHTML) => {
          if (infoBoxHTML) {
            const marker = L.marker(geoJsonCenter, { icon: customIcon }).addTo(layerGroup);
            //const marker = L.marker(geoJsonCenter).addTo(layerGroup);
            //map.flyTo(geoJsonCenter, map_maxZoomLevel);

            const latOffset = 0.0013;
            const adjustedLat = geoJsonCenter[0] + latOffset;
            const adjustedCenter = [adjustedLat, geoJsonCenter[1]];
            map.flyTo(adjustedCenter, map_maxZoomLevel);
            marker.bindPopup(infoBoxHTML).openPopup();

          } else {
            console.error(`Failed to generate info box HTML for ID: ${geoJsonId}`);
            alert("The location could not be found on the map.");
          }
        });
      } else {
        console.error(`GeoJSON center not found for ID: ${geoJsonId}`);
        alert("The location could not be found on the map.");
      }
    }
  }
};

export const mapMakerGeoJsonObject_byIDs = (map, geoJsonId_array, flyToCoord, activeLang, customIcon = defaultMarkerIcon) => {
//export const mapMakerGeoJsonObject_byIDs = (map, geoJsonId_array, flyToCoord, activeLang) => {
  if (map) {
    mapClearAllLayerContents(map);
    const layerGroup = L.layerGroup().addTo(map);
    layerGroup.type = 'location'; 

    if (geoJsonId_array && geoJsonId_array.length > 0) {
      geoJsonId_array.forEach((geoJsonId) => {
        const geoJsonCenter = mapGetGeoJsonObjectCenter(geoJsonId);

        if (geoJsonCenter) {
          generateInfoBoxHTML(geoJsonId, activeLang, (infoBoxHTML) => {
            if (infoBoxHTML) {
              const marker = L.marker(geoJsonCenter, { icon: customIcon }).addTo(layerGroup);
              //const marker = L.marker(geoJsonCenter).addTo(layerGroup);
              marker.bindPopup(infoBoxHTML);
            } else {
              console.error(`Failed to generate info box HTML for ID: ${geoJsonId}`);
            }
          });
        } else {
          console.error(`GeoJSON center not found for ID: ${geoJsonId}`);
        }
      });
    }

    if (flyToCoord) {
      map.flyTo(flyToCoord, map_defaultZoomLevel);
    }
  }
};
  
  // Leaflet functions
export const mapClearAllLayers = (map) => {
  map.eachLayer((layer) => {
    map.removeLayer(layer);
  });
};
  
export const mapListMapLayers = (map) => {
  const layers = [];
  map.eachLayer((layer) => {
    layers.push({
      id: layer._leaflet_id,
      name: layer.options.name,
    });
  });
  return layers;
};
  
export const mapClearLayerByName = (map, layerName) => {
  map.eachLayer((layer) => {
    if (layer.options && layer.options.name === layerName) {
      map.removeLayer(layer);
    }
  });
};
  
export const mapClearLayerByNameUndefined = (map) => {
  map.eachLayer((layer) => {
    if (layer.options && layer.options.name === undefined) {
      map.removeLayer(layer);
    }
  });
};
  
export const mapRemoveAllLayersByID = (map, id) => {
  map.eachLayer((layer) => {
    //if (layer._leaflet_id !== 0) {
    if (layer._leaflet_id === id) {
      map.removeLayer(layer);
    }
  });
};

export const mapClearLayerContents = (layer) => {
  if (layer instanceof L.LayerGroup) {
    //layer.clearLayers();
  } else if (layer instanceof L.Marker) {
    layer.remove();
  } else if (layer instanceof L.Polyline || layer instanceof L.Polygon) {
    //layer.remove();
  }
};
export const mapClearAllLayerContents = (map) => {
  map.closePopup();    
  map.eachLayer((layer) => {
    mapClearLayerContents(layer);
  });
  //dispatch(clearWaypoints());
  //dispatch(clearRoutes());      
};

export const mapClearLocationLayerGroup = (map) => {
  map.closePopup();    
  map.eachLayer((layer) => {
    if (layer instanceof L.LayerGroup && layer.type === 'location') {
      layer.clearLayers();
    }
  });
};


export const getCurrentUserCoordinates = (callback) => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        callback(null, [latitude, longitude]);
      },
      (error) => {
        callback(error, null);
      }
    );
  } else {
    callback(new Error("Geolocation is not supported by this browser."), null);
  }
};

export const isInsidePolygon = (point, polygon) => {
  let crossings = 0;
  for (let i = 0; i < polygon.length; i++) {
    let a = polygon[i];
    let b = polygon[(i + 1) % polygon.length];

    if ((a[1] <= point[1] && point[1] < b[1]) || (b[1] <= point[1] && point[1] < a[1])) {
      let x = a[0] + ((b[0] - a[0]) * (point[1] - a[1])) / (b[1] - a[1]);
      if (x > point[0]) {
        crossings++;
      }
    }
  }
  return crossings % 2 === 1;
};

export const PolygonChecker = ({ point, polygon }) => {

  const inside = isInsidePolygon(point, polygon);

  return (
    <div>
      <h1>Point Checker</h1>
      <p>Point: {`(${point[0]}, ${point[1]})`}</p>
      <p>Polygon: {JSON.stringify(polygon)}</p>
      <p>{inside ? 'The point is inside the polygon.' : 'The point is outside the polygon.'}</p>
    </div>
  );
};



export const forward_geocode_by_um = (userInput) =>{
  let result = [];
  buildings.forEach((building) => {
    if((building.properties.name !== undefined) && building.properties.name.includes(userInput)){
      result.push(building)
    }
  });
  return result
}

export const getGeoJsonResults_bySearchInput = (userInput) => {
  
  if (!userInput) {
    return [];
  } else if (!userInput.trim()) {
    return [];
  }

  let result = [];
  const lowerCaseInput = userInput.trim().toLowerCase();

  buildings.forEach((building) => {
    const name = building.properties.name ? building.properties.name.toLowerCase() : '';
    const nameZh = building.properties["name:zh"] ? building.properties["name:zh"].toLowerCase() : '';
    const nameEn = building.properties["name:en"] ? building.properties["name:en"].toLowerCase() : '';
    const shortname = building.properties.shortname ? building.properties.shortname.toLowerCase() : '';

    if (
      (name.includes(lowerCaseInput) ||
      nameZh.includes(lowerCaseInput) ||
      nameEn.includes(lowerCaseInput) ||
      shortname.includes(lowerCaseInput)) &&
      isInsidePolygon(mapGetGeoJsonObjectCenter(building.properties["@id"]), polygon_UmEmap)
    ) {
      result.push(building);
    }
  });

  result.sort((a, b) => {
    const nameA = a.properties["name:en"] ? a.properties["name:en"].toLowerCase() : '';
    const nameB = b.properties["name:en"] ? b.properties["name:en"].toLowerCase() : '';
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });

  // Limit the results to a maximum of 15
  if (result.length > 15) {
    result = result.slice(0, 15);
  }

  return result;
};


export const forward_geocode_by_geoJsonId = (geoJsonId) =>{

  let result = [];
    
  buildings.forEach((building) => {
    if((building.properties['@id'] !== undefined) && building.properties['@id'].includes(geoJsonId)){
      result.push(building)
    }
  });
  return result
}



export const reverse_geocode_by_um = (lon, lat) =>
  axios.get(NOMINATIME_URL_REVERSE, {
    params: {
      lon: lon,
      lat: lat,
      format: 'json',
    },
  })

  export const parseGeocodeResponseByUM = (results, lngLat) => {
    if (!(Object.prototype.toString.call(results) === '[object Array]')) {
      results = [results]
    }
    const processedResults = []
    for (const [index, result] of results.entries()) {
      if (
        'error' in result &&
        result.error.toLowerCase() === 'unable to geocode'
      ) {
        processedResults.push({
          title: lngLat.toString(),
          description: '',
          selected: true,
          addresslnglat: '',
          sourcelnglat: lngLat,
          displaylnglat: lngLat,
          key: index,
          addressindex: index,
          umresult: result,
        })
      } else {
        let routingSrcCoordinates = getOsmObjectCenter(result);
        processedResults.push({
          title: result.properties.name,
          description: '',
          selected: false,
          addresslnglat: [routingSrcCoordinates[1], routingSrcCoordinates[0]],
          sourcelnglat:
            lngLat === undefined
              ? [routingSrcCoordinates[1], routingSrcCoordinates[0]]
              : lngLat,
          displaylnglat:
            lngLat !== undefined
              ? lngLat
              : [routingSrcCoordinates[1], routingSrcCoordinates[0]],
          key: index,
          addressindex: index,
          umresult: result,
        })
      }
    }
    return processedResults
  }
  
function getOsmObjectCenter(building) {

  let buildingGeometry = building.geometry;
  let buildingCoordinates = building.geometry.coordinates;

  if (buildingGeometry.type === 'Polygon') {
    // Calculate the centroid of the polygon
    let centroid = L.polygon(buildingCoordinates).getBounds().getCenter();
    return [centroid.lng, centroid.lat];
  } else if (buildingGeometry.type === 'Point') {
    // Return the coordinates of the point
    return [buildingCoordinates[1], buildingCoordinates[0]];
  }
  // Return null if the building ID is not found or the geometry type is not supported
  return null;
}            
  
